"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyEnhancedTable = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const immutable_1 = require("immutable");

const memoize_one_1 = __importDefault(require("memoize-one"));

const react_1 = __importStar(require("react"));

const SskyEnhancedTableHead_1 = __importDefault(require("../SskyEnhancedTableHead"));

const SskyTableCell_1 = __importDefault(require("../SskyTableCell"));

const SortInfo = (0, immutable_1.Record)({
  orderBy: undefined,
  order: "asc"
});

class SskyEnhancedTable extends react_1.PureComponent {
  constructor() {
    super(...arguments);
    this.showSelection = this.props.selectionType !== "none";
    this.state = {
      page: 0,
      rowsPerPage: this.props.rowsPerPage
    };
    this.memoizeSort = (0, memoize_one_1.default)(SskyEnhancedTable.sort);

    this.handleRequestSort = (event, property) => {
      let {
        sortOrderList
      } = this.state;
      let index = sortOrderList.findIndex(info => info.orderBy === property);
      let info = sortOrderList.get(index);

      if (index !== 0) {
        sortOrderList = sortOrderList.delete(index);
        sortOrderList = sortOrderList.unshift(new SortInfo({
          orderBy: info.orderBy
        }));
      } else {
        let order = info.order === "asc" ? "desc" : "asc";
        sortOrderList = sortOrderList.set(index, new SortInfo({
          orderBy: info.orderBy,
          order
        }));
      }

      this.setState({
        sortOrderList
      });
    };

    this.handleSelectAllClick = (event, checked) => {
      var _a, _b;

      let selected = [];

      if (checked) {
        selected = this.props.data.map(n => n.id);
      }

      (_b = (_a = this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, selected, this.getSelectedIndexes(selected));
    };

    this.handleClick = (event, id) => {
      var _a, _b;

      let {
        selected
      } = this.props;

      if (!selected) {
        selected = [];
      }

      const selectedIndex = selected.indexOf(id);
      let lastSelected = selected[selected.length - 1];
      let newSelected = [];

      if (!this.props.multiSelection) {
        if (selectedIndex === -1) {
          newSelected.push(id);
        }
      } else {
        if (selectedIndex === -1) {
          let lastRenderedIndex = this.sortedData.findIndex(row => row.id === lastSelected);

          if (!event.nativeEvent.shiftKey) {
            newSelected = newSelected.concat(selected, id);
          } else {
            let chosenRenderedIndex = this.sortedData.findIndex(row => row.id === id);

            if (lastRenderedIndex > chosenRenderedIndex) {
              for (chosenRenderedIndex; chosenRenderedIndex <= lastRenderedIndex; ++chosenRenderedIndex) {
                newSelected.push(this.sortedData[chosenRenderedIndex].id);
              }
            } else {
              for (chosenRenderedIndex; chosenRenderedIndex >= lastRenderedIndex; --chosenRenderedIndex) {
                newSelected.push(this.sortedData[chosenRenderedIndex].id);
              }
            }
          }
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }
      }

      (_b = (_a = this.props).onSelect) === null || _b === void 0 ? void 0 : _b.call(_a, newSelected, this.getSelectedIndexes(newSelected));
    };

    this.getSelectedIndexes = selected => {
      var _a;

      return (_a = selected === null || selected === void 0 ? void 0 : selected.reduce((acc, id) => {
        acc.push(this.sortedData.findIndex(row => row.id === id));
        return acc;
      }, [])) !== null && _a !== void 0 ? _a : [];
    };

    this.handleChangePage = (event, page) => {
      this.setState({
        page
      });
    };

    this.handleChangeRowsPerPage = event => {
      this.setState({
        rowsPerPage: event.target.value
      });
    };

    this.renderData = () => {
      const {
        data,
        headers,
        pagination,
        sortPasses,
        optimizedSort,
        onRenderData,
        onRenderRow,
        onRenderCell
      } = this.props;
      const {
        rowsPerPage,
        page,
        sortOrderList
      } = this.state;
      this.sortedData = optimizedSort ? this.memoizeSort(data, headers, sortOrderList, sortPasses) : SskyEnhancedTable.sort(data, headers, sortOrderList, sortPasses);
      let renderedRows = pagination ? this.sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : this.sortedData;

      if (onRenderData) {
        onRenderData(this.sortedData, renderedRows);
      }

      return renderedRows.map((row, index) => {
        if (onRenderRow) {
          onRenderRow(row.id);
        }

        const isSelected = this.isSelected(row.id);
        return react_1.default.createElement(material_1.TableRow, {
          hover: true,
          role: "checkbox",
          "aria-checked": isSelected,
          tabIndex: -1,
          key: row.id,
          selected: isSelected,
          className: (0, classnames_1.default)(row.className, row.disabled ? "disabled-row" : ""),
          onClick: e => {
            !this.showSelection && !this.props.disableSelection && this.handleClick(e, row.id);
          },
          onMouseEnter: () => {
            var _a, _b;

            return (_b = (_a = this.props).onRowHover) === null || _b === void 0 ? void 0 : _b.call(_a, index);
          },
          onMouseLeave: () => {
            var _a, _b;

            return (_b = (_a = this.props).onRowHover) === null || _b === void 0 ? void 0 : _b.call(_a, null);
          }
        }, this.showSelection && react_1.default.createElement(material_1.TableCell, {
          padding: "checkbox",
          className: "checkBoxCell"
        }, this.props.selectionType === "radio" ? react_1.default.createElement(material_1.Radio, {
          color: "primary",
          disabled: row.disabled || this.props.disableSelection,
          checked: isSelected,
          onChange: event => this.handleClick(event, row.id),
          "data-testid": `testId-${row.id}-checkbox`
        }) : react_1.default.createElement(material_1.Checkbox, {
          color: "primary",
          disabled: row.disabled || this.props.disableSelection,
          checked: isSelected,
          onChange: event => this.handleClick(event, row.id),
          "data-testid": `testId-${row.id}-checkbox`
        })), headers.map(cell => {
          const properties = row[cell.id];

          if (onRenderCell) {
            onRenderCell(row.id, cell.id, properties);
          }

          if (properties) {
            const {
              span,
              value,
              className
            } = properties;
            return react_1.default.createElement(material_1.TableCell, {
              key: row.id + "" + cell.id,
              className: className,
              sx: {
                root: {
                  fontSize: "12px"
                }
              },
              align: cell.numeric ? "right" : "inherit",
              colSpan: span || 1
            }, value);
          }
        }));
      });
    };

    this.isSelected = id => {
      return this.props.selected ? this.props.selected.indexOf(id) !== -1 : false;
    };
  }

  static getDerivedStateFromProps(props, state) {
    const {
      headers,
      defaultOrder
    } = props;
    let sortableHeaders = headers.filter(col => col.sortable);

    if (state.headersUsedForSortOrderList && SskyEnhancedTable.areHeadersEqual(state.headersUsedForSortOrderList, sortableHeaders)) {
      return null;
    }

    return {
      sortOrderList: SskyEnhancedTable.defaultSortOrderList(sortableHeaders, defaultOrder),
      headersUsedForSortOrderList: SskyEnhancedTable.cloneHeaders(sortableHeaders)
    };
  }

  static areHeadersEqual(headers1, headers2) {
    if (headers1.length !== headers2.length) {
      return false;
    }

    for (let i = 0; i < headers1.length; ++i) {
      if (!Object.keys(headers1[i]).every(prop => headers1[i][prop] === headers2[i][prop])) {
        return false;
      }
    }

    return true;
  }

  static cloneHeaders(headers) {
    return headers.map(header => Object.assign({}, header));
  }

  static rowComparatorPass(rowA, rowB, headers, sortOrderList, pass) {
    let rowResult = 0;
    sortOrderList.forEach(info => {
      let cellA = SskyEnhancedTable.findCell(rowA, info.orderBy, headers);
      let cellB = SskyEnhancedTable.findCell(rowB, info.orderBy, headers);
      let column = headers.find(col => col.id === info.orderBy);
      let cellResult = column.sortComparator ? column.sortComparator(cellA, cellB, info.orderBy, info.order, pass) : SskyEnhancedTable.defaultCellComparator(cellA, cellB, info.order);

      if (cellResult !== 0) {
        rowResult = cellResult;
        return false;
      }
    });
    return rowResult;
  }

  render() {
    var _a;

    const {
      className,
      data,
      headers,
      multiSelection,
      selected,
      pagination,
      fillPage,
      rowsPerPageOptions
    } = this.props;
    const {
      rowsPerPage,
      page,
      sortOrderList
    } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
    return react_1.default.createElement(material_1.Paper, {
      className: className,
      sx: {
        color: this.props.disabled ? "#eeeeee" : this.props.backgroundColor,
        boxShadow: "none"
      }
    }, this.props.topBar, react_1.default.createElement("div", {
      className: "tableDiv"
    }, react_1.default.createElement(material_1.Table, {
      "aria-labelledby": "tableTitle",
      stickyHeader: this.props.stickyHeader
    }, react_1.default.createElement(SskyEnhancedTableHead_1.default, {
      numSelected: (_a = selected === null || selected === void 0 ? void 0 : selected.length) !== null && _a !== void 0 ? _a : 0,
      order: sortOrderList.size > 0 ? sortOrderList.get(0).order : "",
      orderBy: sortOrderList.size > 0 ? sortOrderList.get(0).orderBy : "",
      onSelectAllClick: this.handleSelectAllClick,
      onRequestSort: this.handleRequestSort,
      rowCount: data.length,
      columnData: headers,
      multiSelection: multiSelection && this.props.selectionType === "checkbox",
      renderSelectionCell: this.showSelection,
      selectionCellHeader: this.props.selectionCellHeader,
      disableSelection: this.props.disableSelection
    }), react_1.default.createElement(material_1.TableBody, null, this.renderData(), emptyRows > 0 && pagination && fillPage && react_1.default.createElement(material_1.TableRow, {
      style: {
        height: 49 * emptyRows
      }
    }, react_1.default.createElement(SskyTableCell_1.default, {
      span: headers.length + 1
    }))))), pagination && react_1.default.createElement(material_1.TablePagination, {
      component: "div",
      count: data.length,
      rowsPerPage: rowsPerPage,
      page: page,
      backIconButtonProps: {
        "aria-label": "Previous Page"
      },
      nextIconButtonProps: {
        "aria-label": "Next Page"
      },
      rowsPerPageOptions: rowsPerPageOptions,
      onPageChange: this.handleChangePage,
      onRowsPerPageChange: this.handleChangeRowsPerPage
    }));
  }

}

exports.SskyEnhancedTable = SskyEnhancedTable;
SskyEnhancedTable.defaultProps = {
  backgroundColor: "#fff",
  defaultOrder: "asc",
  fillPage: true,
  multiSelection: true,
  optimizedSort: false,
  pagination: true,
  rowsPerPage: 60,
  rowsPerPageOptions: [20, 40, 60, 100],
  sortPasses: 1,
  selectionType: "checkbox"
};

SskyEnhancedTable.defaultSortOrderList = (sortableHeaders, order) => {
  return (0, immutable_1.List)(sortableHeaders.map(col => {
    return new SortInfo({
      orderBy: col.id,
      order
    });
  }));
};

SskyEnhancedTable.sort = (data, headers, sortOrderList, sortPasses) => {
  return data.slice().sort((a, b) => SskyEnhancedTable.rowComparator(a, b, headers, sortOrderList, sortPasses));
};

SskyEnhancedTable.rowComparator = (rowA, rowB, headers, sortOrderList, sortPasses) => {
  let result = 0;

  for (let pass = 0; pass < sortPasses && result === 0; ++pass) {
    result = SskyEnhancedTable.rowComparatorPass(rowA, rowB, headers, sortOrderList, pass);
  }

  return result;
};

SskyEnhancedTable.findCell = (row, orderBy, headers) => {
  let cell = row[orderBy];

  if (cell) {
    return cell;
  }

  let idx = headers.findIndex(header => header.id === orderBy);

  while (!cell && idx > 0) {
    orderBy = headers[--idx].id;
    cell = row[orderBy];
  }

  return cell;
};

SskyEnhancedTable.defaultCellComparator = (cellA, cellB, order) => {
  let result = 0;

  if (cellA.value > cellB.value) {
    result = 1;
  } else if (cellA.value < cellB.value) {
    result = -1;
  }

  if (result !== 0 && order === "desc") {
    result = -result;
  }

  return result;
};

exports.default = SskyEnhancedTable;